import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PageHero, { usePageMeta } from "@/components/marketing/PageHero";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import { useI18n, useL } from "@/context/I18nContext";
import api from "@/lib/api";

export default function Prezzi() {
  const { lang } = useI18n();
  const L = useL();
  usePageMeta(L("Prezzi", "Pricing", "Preise"), L("Come funziona il compenso per i servizi di Recovers Crypto: definito dopo la valutazione tecnica, sempre per iscritto.", "How the fee for Recovers Crypto services works: defined after the technical assessment, always in writing.", "So funktioniert die Vergütung für Recovers-Crypto-Dienste: nach der technischen Bewertung festgelegt, stets schriftlich."));
  const [settings, setSettings] = useState(null);
  useEffect(() => { api.get("/content/settings").then(({ data }) => setSettings(data)).catch(() => {}); }, []);

  const serverText = lang === "de" ? settings?.pricing_text_de : lang === "en" ? settings?.pricing_text_en : settings?.pricing_text_it;
  const pricingText = serverText
    || L("Il compenso viene definito dopo la valutazione tecnica e comunicato tramite preventivo e contratto scritti.", "The fee is defined after the technical assessment and communicated through a written quote and contract.", "Die Vergütung wird nach der technischen Bewertung festgelegt und über ein schriftliches Angebot und einen Vertrag mitgeteilt.");

  const bullets = [
    L("Valutazione preliminare della fattibilità tecnica", "Preliminary assessment of technical feasibility", "Vorläufige Bewertung der technischen Machbarkeit"),
    L("Preventivo scritto con ambito e condizioni", "Written quote with scope and conditions", "Schriftliches Angebot mit Umfang und Bedingungen"),
    L("Contratto prima dell'avvio della lavorazione", "Contract before work begins", "Vertrag vor Arbeitsbeginn"),
    L("Fattura e ricevuta per ogni pagamento registrato", "Invoice and receipt for every recorded payment", "Rechnung und Beleg für jede erfasste Zahlung"),
  ];

  return (
    <div>
      <PageHero eyebrow={L("Prezzi", "Pricing", "Preise")} title={L("Un modello di compenso trasparente", "A transparent fee model", "Ein transparentes Vergütungsmodell")}
        subtitle={L("Il compenso viene definito solo dopo la valutazione tecnica preliminare e comunicato in un preventivo scritto.", "The fee is defined only after the preliminary technical assessment and communicated in a written quote.", "Die Vergütung wird erst nach der technischen Voranalyse festgelegt und in einem schriftlichen Angebot mitgeteilt.")} />
      <section className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="rounded-xl border border-white/10 bg-navy-paper p-8">
          <p className="text-slate-300 leading-relaxed" data-testid="pricing-text">{pricingText}</p>
          <ul className="mt-6 space-y-2.5">
            {bullets.map((x) => (
              <li key={x} className="flex items-center gap-2.5 text-sm text-slate-300"><Check className="h-4 w-4 text-cyanx shrink-0" />{x}</li>
            ))}
          </ul>
          <p className="mt-6 text-xs text-slate-500">
            {L("Nessun costo nascosto: non applichiamo commissioni di \"sblocco fondi\", di rilascio di rete o di liquidità.", "No hidden costs: we do not charge \"fund unlock\", network release or liquidity fees.", "Keine versteckten Kosten: Wir erheben keine Gebühren für \"Fondsfreischaltung\", Netzwerkfreigabe oder Liquidität.")}
          </p>
        </div>
        <div className="mt-10 flex justify-center">
          <Button asChild size="lg" className="bg-gold text-navy hover:bg-gold-hover"><Link to="/avvia-recupero">{L("Richiedi una valutazione", "Request an assessment", "Bewertung anfragen")}</Link></Button>
        </div>
      </section>
    </div>
  );
}
